import { Reducer } from "redux";

import { MaintenanceState } from "modules/maintenance/models";
import { HandledAction } from "./actionCreator";

export type KnownAction = HandledAction;

export const reducer: Reducer<MaintenanceState> = (state: MaintenanceState, action: KnownAction) => {
    switch (action.type) {
        case "GET_MONTH_END_STATUS_INIT": {
            return {
                ...state,
                isFetching: true
            };
        }
        case "GET_MONTH_END_STATUS_COMPLETE": {
            return {
                ...state,
                isFetching: false,
                monthEnd: action.monthEnd
            };
        }
        default:
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const exhaustiveCheck: never = action;
    }
    return (
        // Unlocked until the first response lands, so the page does not flash the maintenance
        // message on every load. Fail-closed lives in the API and in the action creator.
        state || {
            isFetching: false,
            monthEnd: null
        }
    );
};
